import {FormAppContext, FormCategories, FormDefinition, FormDefinitions, FormLists, FormMethods} from "@t/fd/layout/FormDefinition.ts";
import {FormLayout} from "@t/fd/layout/FormLayout.ts";

export interface RootLayout extends FormLayout {
}

export interface InterfaceRoot<T extends RootLayout> extends FormLayout {
	type: "interface";
	version?: number;

	/** If the content is missing, then it is expected that content is the default slot */
	content?: T;

	lists?: FormLists;
	categories?: FormCategories;
	define?: FormDefinitions;
	methods?: FormMethods;

	/** Additional script source */
	script?: string;

	/**
	 * Rules to build app context dynamically
	 * Final context is built using fixed values then merged with externally
	 * provided values and finally dynamically from form data.
	 **/
	context?: FormAppContext;

	/** Show the interface (form/agenda) in debug mode */
	debug?: boolean;
}

export function isFormRoot(root:InterfaceRoot<any>):root is InterfaceRoot<FormDefinition> {
	return root?.content?.type === "form";
}